// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__dr0t2","animation":"styles_animation__eRv15","primary":"styles_primary__pwZzd","quatenary":"styles_quatenary__UQHN_"};